import { render } from "./NewData.vue?vue&type=template&id=ce4c3b1c"
import script from "./NewData.vue?vue&type=script&lang=js"
export * from "./NewData.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__